import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { API_TIMEOUT_TIERS } from '#pplx/frontend/api-clients/core/utils.js';
import { getPinnedItemsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/threadKeys.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { pinsClient } from '#pplx_generated/typespec/rest/pins/client.js';
const PINNED_ITEMS_LIMIT = 50;
export function usePinnedItemsQuery({ enabled = true, reason, }) {
    return useQuery({
        queryKey: getPinnedItemsQueryKey({ limit: PINNED_ITEMS_LIMIT }),
        queryFn: async () => {
            const { data, error, response } = await pinsClient.GET('/rest/pins', reason, {
                params: { query: { limit: PINNED_ITEMS_LIMIT } },
                timeoutMs: API_TIMEOUT_TIERS.MEDIUM,
            });
            if (error || !data) {
                throw new ApiClientsError('API_CLIENTS_ERROR', {
                    message: 'Failed to list pinned items',
                    cause: error,
                    status: response.status ?? 0,
                });
            }
            return data.items;
        },
        enabled,
        placeholderData: EMPTY_ARRAY,
        staleTime: 30_000,
    });
}
//# sourceMappingURL=usePinnedItemsQuery.js.map